var _circle, _path, _g, _g2, _path2, _g3, _path3, _g4, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllSsoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 164.656,
    r: 100,
    fill: "#9AA0DA",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6073 245.994L30.2259 118.761C28.3508 112.379 32.5256 105.806 39.0996 104.79L159.406 86.1951C163.722 85.5281 167.894 88.0553 169.301 92.1891L208.921 208.573C211.009 214.707 207.371 221.307 201.07 222.816L78.3385 252.209C73.677 253.326 68.9585 250.593 67.6073 245.994Z",
    fill: "url(#paint0_linear_14402_25185)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_i_14402_25185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2057 242.968L32.3232 114.805C30.9331 110.102 34.0027 105.251 38.848 104.493L160.326 85.5024C164.207 84.8957 167.965 87.1576 169.246 90.8711L209.94 208.87C211.506 213.412 208.803 218.313 204.125 219.41L79.8351 248.564C75.6492 249.546 71.4244 247.091 70.2057 242.968Z",
    fill: "url(#paint1_linear_14402_25185)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.656 124.57C102.6 131.378 95.557 138.199 88.5266 145.031C87.4115 145.932 87.1312 147.486 87.5342 148.796C87.9785 150.24 89.2178 151.478 90.728 151.846C98.7565 153.707 121.565 158.932 121.565 158.932C121.565 158.932 127.134 154.753 127.882 154.192C129.974 152.624 132.067 151.057 134.16 149.491C127.358 143.461 120.564 137.422 113.777 131.376C112.862 130.561 111.946 129.746 111.03 128.931C110.773 128.703 110.516 128.474 110.259 128.246C110.188 128.183 110.107 127.983 109.983 128.004C109.629 127.651 109.319 127.231 109.169 126.754C108.936 126.01 109.085 125.135 109.656 124.57Z",
    fill: "#2DB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.158 149.488C129.957 152.632 121.562 158.929 121.562 158.929C121.562 158.929 142.594 163.694 151.936 165.783C152.455 165.92 152.954 166.14 153.388 166.452C146.969 160.806 140.56 155.152 134.158 149.488Z",
    fill: "#7280FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.978 128.002C118.023 135.179 126.082 142.34 134.155 149.487C137.533 146.96 140.912 144.436 144.294 141.914L144.293 141.912C145.425 141.042 145.691 139.488 145.277 138.197C144.866 136.914 143.823 135.806 142.524 135.347L142.519 135.334C132.257 131.645 122.003 127.933 111.758 124.198C111.394 124.072 110.998 124.029 110.617 124.095C109.358 124.312 108.815 125.639 109.164 126.752C109.314 127.231 109.578 127.681 109.978 128.002Z",
    fill: "#00D5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.235 190.07C125.079 182.903 116.938 175.721 108.811 168.524C105.309 171.164 101.809 173.805 98.3116 176.45L98.3121 176.451C97.1356 177.367 96.8251 178.987 97.2439 180.348C97.6525 181.676 98.722 182.827 100.071 183.284L100.074 183.298C110.53 186.903 120.994 190.484 131.468 194.04L131.469 194.038C131.836 194.156 132.235 194.188 132.614 194.108C133.884 193.838 134.413 192.457 134.057 191.326C133.906 190.844 133.64 190.389 133.235 190.07Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.579 193.585C140.431 186.531 147.295 179.487 154.171 172.454C155.238 171.543 155.479 170.015 155.069 168.737C154.621 167.337 153.412 166.133 151.938 165.784L151.938 165.783C141.808 163.517 131.682 161.232 121.562 158.928C117.308 162.122 113.057 165.321 108.809 168.523C116.936 175.721 125.077 182.903 133.233 190.07C133.591 190.424 133.903 190.846 134.054 191.326C134.295 192.092 134.144 192.989 133.579 193.585Z",
    fill: "#FF3F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.811 168.524C113.058 165.322 117.309 162.124 121.562 158.929C111.278 156.588 100.999 154.226 90.7248 151.845C90.1963 151.702 89.6892 151.479 89.2485 151.158C95.7602 156.957 102.281 162.745 108.811 168.524Z",
    fill: "#7280FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14402_25185",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 85,
    width: 180,
    height: 164
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2057 242.968L32.3232 114.805C30.9331 110.102 34.0027 105.251 38.848 104.493L160.326 85.5024C164.207 84.8957 167.965 87.1576 169.246 90.8711L209.94 208.87C211.506 213.412 208.803 218.313 204.125 219.41L79.8351 248.564C75.6492 249.546 71.4244 247.091 70.2057 242.968Z",
    fill: "url(#paint2_linear_14402_25185)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14402_25185)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.452 228.316L318.82 99.2295C320.343 92.7542 315.815 86.4191 309.195 85.764L188.052 73.776C183.706 73.346 179.679 76.0975 178.5 80.3021L145.303 198.679C143.554 204.917 147.548 211.308 153.921 212.471L278.077 235.109C282.792 235.968 287.354 232.982 288.452 228.316Z",
    fill: "url(#paint3_linear_14402_25185)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 207.413L347.417 60.5645C348.638 54.0253 343.82 47.9076 337.177 47.5612L200.15 40.4145C195.789 40.1871 191.894 43.1229 190.912 47.3779L159.758 182.329C158.3 188.641 162.587 194.84 169.008 195.705L309.961 214.681C314.711 215.321 319.129 212.125 320.009 207.413Z",
    fill: "url(#paint4_linear_14402_25185)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14402_25185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.819 204.269L344.595 56.7878C345.503 51.9685 341.959 47.4524 337.062 47.1886L199.14 39.7564C195.218 39.545 191.708 42.175 190.809 45.9989L158.739 182.44C157.64 187.117 160.825 191.719 165.589 192.338L307.804 210.81C312.068 211.364 316.023 208.494 316.819 204.269Z",
    fill: "url(#paint5_linear_14402_25185)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.225 121.305C287.721 118.84 288.021 116.333 288.083 113.819C276.636 112.819 265.189 111.818 253.741 110.818C252.779 115.42 251.817 120.022 250.855 124.624C257.386 125.247 263.917 125.87 270.448 126.493C269.577 128.716 268.273 130.763 266.651 132.515C265.016 134.282 263.057 135.748 260.897 136.812C260.272 139.841 259.647 142.87 259.023 145.9C262.954 146.32 266.885 146.741 270.817 147.161C279.559 141.174 285.156 131.594 287.225 121.305Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.856 153.313C253.937 154.33 263.231 152.353 270.814 147.166C267.511 143.712 264.204 140.26 260.895 136.811C256.877 138.826 252.295 139.469 247.847 139.007C245.74 138.789 243.668 138.243 241.74 137.364C235.729 134.621 231.658 128.772 230.899 122.241C226.993 121.869 223.086 121.498 219.179 121.126C218.524 124.157 217.868 127.187 217.213 130.217C218.859 136.309 222.347 141.822 227.181 145.883C232.166 150.073 238.401 152.596 244.855 153.318",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.899 122.241C230.345 117.553 231.479 112.772 233.796 108.684C234.443 105.653 235.091 102.622 235.738 99.5914C231.841 99.2728 227.943 98.9537 224.046 98.6351C220.616 103.192 218.11 108.461 216.902 114.044C215.745 119.367 215.787 124.944 217.214 130.212C221.779 127.559 226.341 124.9 230.901 122.236L230.899 122.241Z",
    fill: "#FABB05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.9 95.6962C261.854 96.0857 266.529 98.2148 269.629 102.174L269.627 102.179C273.797 99.0308 277.962 95.8778 282.124 92.7193C279.035 88.9331 275.048 85.9484 270.532 84.0766C267.137 82.6696 263.506 81.8939 259.845 81.6357C253.052 81.1564 246.192 82.6174 240.06 85.5413C233.776 88.5377 228.231 93.0683 224.05 98.636C227.303 101.983 230.553 105.332 233.8 108.685C238.351 100.622 247.516 94.9587 256.906 95.6967",
    fill: "#E94235"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14402_25185",
    x: 31.9873,
    y: 85.4045,
    width: 178.399,
    height: 163.376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14402_25185"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14402_25185",
    x: 158.521,
    y: 39.7445,
    width: 186.216,
    height: 171.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14402_25185"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14402_25185",
    x1: 42.6541,
    y1: 111.066,
    x2: 204.871,
    y2: 217.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14402_25185",
    x1: 57.4617,
    y1: 115.706,
    x2: 153.093,
    y2: 179.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14402_25185",
    x1: 97.6897,
    y1: 147.087,
    x2: 175.981,
    y2: 181.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14402_25185",
    x1: 220.097,
    y1: 224.125,
    x2: 94.4947,
    y2: 109.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E7F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14402_25185",
    x1: 332.59,
    y1: 54.814,
    x2: 170.799,
    y2: 189.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504877,
    stopColor: "#D4D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14402_25185",
    x1: 192.814,
    y1: 35.5516,
    x2: 267.989,
    y2: 197.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSsoGoogle);
export default __webpack_public_path__ + "static/media/ill-sso-google.69ce9e60abac2918ff30ad18b7cc9aa5.svg";
export { ForwardRef as ReactComponent };